import lockupLight from "@/images/tuw-logo.png"
import lockupDark from "@/images/tuw-logo-white.png"

import { cn } from "@/lib/utils"

// The `dibbly | The Urban Writers` co-brand lockup, one PNG per theme, swapped
// by the `.dark` class. The auth screens are where the product is introduced,
// so they carry the full lockup rather than the in-app Dibbly wordmark
// (design/docs/DECISIONS.md §Auth).
export default function BrandLockup({ className = "h-[30px]" }) {
  return (
    <>
      <img
        src={lockupLight}
        alt="dibbly | The Urban Writers"
        className={cn("block w-auto dark:hidden", className)}
      />
      <img
        src={lockupDark}
        alt="dibbly | The Urban Writers"
        className={cn("hidden w-auto dark:block", className)}
      />
    </>
  )
}
